import { Address } from './Address'

export default class Company {
    constructor() {
        this.name = ''
        this.phone = ''
        this.fax = ''
        this.website = ''
        this.email = ''
        this.address = new Address()
    }

    static fromAPI(raw = {}) {
        const c = new Company()
        c.name = raw.name ?? ''
        c.phone = raw.phone ?? ''
        c.fax = raw.fax ?? ''
        c.website = raw.website ?? ''
        c.email = raw.email ?? ''
        c.address = Address.fromAPI(raw.address)
        return c
    }

    static fromSources({ webSimulator, company_address } = {}) {
        const c = Company.fromAPI(company_address || {})
        c.name = webSimulator?.companyDisplayName ?? c.name ?? ''
        return c
    }
}
